import { render, staticRenderFns } from "./KnFormExpenses.vue?vue&type=template&id=0a2f0e10"
import script from "./KnFormExpenses.js?vue&type=script&lang=js&external"
export * from "./KnFormExpenses.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports